import { ProductImage } from '@lib/product/definitions';
import { PostImage } from '@lib/post/definitions';

export function getValidImageUrl(
  images: ProductImage[] | PostImage[],
  fallback: string = '',
): string {
  return (
    images.find((img) => img?.imageUrl)?.imageUrl ||
    // TODO: This should not happen; thus, add a fallback image
    fallback
  );
}

export function getValidImageAltText(
  images: ProductImage[] | PostImage[],
  fallback: string = '',
): string {
  return images.find((img) => img?.imageAltText)?.imageAltText || fallback;
}

interface Fallbacks {
  urlFallback?: string;
  altFallback?: string;
}
export function getValidImage(
  images: ProductImage[] | PostImage[],
  { urlFallback, altFallback }: Fallbacks = {},
): { src: string; alt: string } {
  return {
    src: getValidImageUrl(images, urlFallback),
    alt: getValidImageAltText(images, altFallback),
  };
}
